import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import InnerPageLayout from "../Layout/InnerPageLayout";
import { Container, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { getOneProjectItem } from "../../api/api";
import { useQuery } from "react-query";

const TarabutSurvey = () => {
  let { id } = useParams();

  const { i18n, t } = useTranslation();

  const { isLoading, error, data, refetch }: any = useQuery(
    `innerProjectData-${id}`,
    () => getOneProjectItem({ id: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language, refetch]);

  return (
    <InnerPageLayout>
      <Container>
        {isLoading && (
          <center>
            <Spinner
              animation="border"
              role="status"
              className="center-spinner"
            >
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </center>
        )}

        {i18n.language === "en" &&
          data &&
          data?.data?.attributes?.localizations && (
            // JSON.stringify( data?.data?.attributes?.localizations?.data[0].attributes.surveyLink)
            <iframe
              src={
                data?.data?.attributes?.localizations?.data[0].attributes
                  .surveyLink
              }
              style={{ width: "100%", minHeight: "2000px", border: "none" }}
              title="TarabutSurvey"
            />
          )}

        {data &&
        i18n.language !== "en" &&
        data?.data?.attributes?.surveyLink ? (
          <iframe
            src={data.data.attributes.surveyLink}
            style={{ width: "100%", minHeight: "2000px", border: "none" }}
            title="TarabutSurvey"
          />
        ) : (
          ""
        )}
      </Container>
    </InnerPageLayout>
  );
};

export default TarabutSurvey;
